import { defineMessages } from 'react-intl';

export const modalTitleMessages: {
	pimary: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	loom: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	newApps: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	connectWork: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	pimary: {
		defaultMessage: 'Transform teamwork, together',
		description: 'Title for the TWC onboarding modal',
		id: 'townsquare.twc-onboarding-modal.title',
	},
	loom: {
		defaultMessage: 'Create better shareouts with Loom',
		description: 'Title for the Loom variant of the onboarding modal',
		id: 'townsquare.twc-onboarding-modal.loom-title',
	},
	newApps: {
		defaultMessage: 'New apps and features are here',
		description: 'Title for a variant of the onboarding modal',
		id: 'townsquare.twc-onboarding-modal.new-apps-title',
	},
	connectWork: {
		defaultMessage: 'Connect work across Atlassian',
		description: 'Title for a variant of the onboarding modal',
		id: 'townsquare.twc-onboarding-modal.connect-work-title',
	},
});

export const modalDescriptionMessages: {
	primary: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	loom: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	primary: {
		defaultMessage:
			'Collaborating is easier than ever with new apps and features, including AI-powered Search and Chat.',
		description: 'Description text explaining the benefits of the new teamwork features',
		id: 'townsquare.twc-onboarding-modal.description',
	},
	loom: {
		defaultMessage:
			'Loom makes it easy to record videos and streamline communication in the apps you already use:',
		description: 'Description text for the Loom variant explaining video recording capabilities',
		id: 'townsquare.twc-onboarding-modal.loom-description',
	},
});

export const featureMessages: {
	// Jira + Confluence
	jiraFeature: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confluenceFeature: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	jiraConfluenceFeatures: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	// Loom
	loomFeature: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	loomAddDemos: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	loomUseVideos: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	loomShareUpdates: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	// Integrations
	integrationsBringTogether: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	integrationsBringTogetherNoGoals: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	connectIntegrations: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	// TWC Apps
	newAppsOne: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	newAppsTwo: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	atlassianHome: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	// Jira + Confluence
	jiraFeature: {
		defaultMessage: "Map out your team's work and tasks in <bold>Jira</bold>",
		description:
			'Feature description for Jira work mapping capabilities. <bold> wraps the product name to make it bold.',
		id: 'townsquare.twc-onboarding-modal.jira-feature',
	},
	confluenceFeature: {
		defaultMessage: 'Document notes and knowledge in <bold>Confluence</bold>',
		description:
			'Feature description for Confluence documentation capabilities. <bold> wraps the product name to make it bold.',
		id: 'townsquare.twc-onboarding-modal.confluence-feature',
	},
	jiraConfluenceFeatures: {
		defaultMessage:
			'Add context in <bold>Jira</bold> with detailed docs in <bold>Confluence</bold>',
		description:
			'Feature description for Jira and Confluence capabilities. <bold> wraps the product name to make it bold.',
		id: 'townsquare.twc-onboarding-modal.jira-confluence-features',
	},

	// Loom
	loomFeature: {
		defaultMessage: 'Share and embed async video updates with <bold>Loom</bold>',
		description:
			'Feature description for Loom video sharing capabilities. <bold> wraps the product name to make it bold.',
		id: 'townsquare.twc-onboarding-modal.loom-feature',
	},
	loomAddDemos: {
		defaultMessage: 'Add <bold>demos</bold> and walkthroughs of your work in Jira',
		description:
			'Feature description for adding demos in Jira. <bold> wraps the word to make it bold.',
		id: 'townsquare.twc-onboarding-modal.loom-add-demos',
	},
	loomUseVideos: {
		defaultMessage: 'Use videos to give <bold>context</bold> to Confluence pages',
		description:
			'Feature description for using videos in Confluence. <bold> wraps the phrase to make it bold.',
		id: 'townsquare.twc-onboarding-modal.loom-use-videos',
	},
	loomShareUpdates: {
		defaultMessage: 'Use <bold>Loom</bold> to easily share updates and knowledge',
		description:
			'Feature description for using Loom to share knowledge. <bold> wraps the phrase to make it bold.',
		id: 'townsquare.twc-onboarding-modal.loom-share-updates',
	},

	// Integrations
	integrationsBringTogether: {
		defaultMessage: 'Bring it all together with <bold>teams, goals, AI</bold>, and more',
		description:
			'Feature description for integrated capabilities. <bold> wraps the list to make it bold.',
		id: 'townsquare.twc-onboarding-modal.loom-bring-together',
	},
	integrationsBringTogetherNoGoals: {
		defaultMessage: 'Bring it all together with <bold>teams, AI,</bold> and more',
		description:
			'Feature description for integrated teamwork capabilities. <bold> wraps the list of key features to make them bold.',
		id: 'townsquare.twc-onboarding-modal.integration-feature',
	},
	connectIntegrations: {
		defaultMessage: 'Connect work with <bold>teams, AI,</bold> and more',
		description:
			'Feature description for integrated work capabilities. <bold> wraps the list of key features to make them bold.',
		id: 'townsquare.twc-onboarding-modal.connect-integrations',
	},

	// TWC Apps
	newAppsOne: {
		defaultMessage: 'Streamline work with <bold>{appOneName}</bold>',
		description:
			'Feature description for working with only one Teamwork Collection App. <bold> wraps the list of key features to make them bold.',
		id: 'townsquare.twc-onboarding-modal.new-apps-one',
	},
	newAppsTwo: {
		defaultMessage: 'Streamline work with <bold>{appOneName}</bold> and <bold>{appTwoName}</bold>',
		description:
			'Feature description for working with multiple Teamwork Collection Apps. <bold> wraps the list of key features to make them bold.',
		id: 'townsquare.twc-onboarding-modal.new-apps-two',
	},
	atlassianHome: {
		defaultMessage: 'Access all your <bold>work</bold> and <bold>spaces</bold> in Atlassian Home',
		description:
			'Feature description for working in Atlassian Home. <bold> wraps the list of key features to make them bold.',
		id: 'townsquare.twc-onboarding-modal.atlassian-home',
	},
});

export const buttonAndAltMessages: {
	gotItButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	takeATourButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	exploreAtlassianHome: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	exploreLoom: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	closeButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	illustrationAlt: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	gotItButton: {
		defaultMessage: 'Got it',
		description: 'Text for the button to dismiss the TWC onboarding modal',
		id: 'townsquare.twc-onboarding-modal.got-it-button',
	},

	takeATourButton: {
		defaultMessage: 'Take a tour',
		description: 'Text for the button to dismiss the TWC onboarding modal and start spotlight tour',
		id: 'townsquare.twc-onboarding-modal.take-a-tour-button',
	},

	exploreAtlassianHome: {
		defaultMessage: 'Explore Atlassian Home',
		description: 'Button text to explore Atlassian Home in the Loom variant',
		id: 'townsquare.twc-onboarding-modal.explore-atlassian-home',
	},

	exploreLoom: {
		defaultMessage: 'Explore Loom',
		description: 'Button text to explore Loom in the Loom variant',
		id: 'townsquare.twc-onboarding-modal.explore-loom',
	},

	closeButtonLabel: {
		defaultMessage: 'Close onboarding modal',
		description: 'Label for the close button that dismisses the TWC onboarding modal',
		id: 'townsquare.twc-onboarding-modal.close-button-label',
	},

	illustrationAlt: {
		defaultMessage:
			'Illustration showing collaborative teamwork with connected apps and AI-powered features',
		description: 'Alt text for the TWC illustration image displayed in the modal',
		id: 'townsquare.twc-onboarding-modal.illustration-alt',
	},
});

export const iconLabelMessages: {
	jiraIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confluenceIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	loomIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	integrationIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	atlassianLogoLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	appsIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	homeIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	teamsIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	alignTextLeftLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	jiraIconLabel: {
		defaultMessage: 'Jira',
		description: 'Accessibility label for the Jira tasks icon',
		id: 'townsquare.twc-onboarding-modal.jira-icon-label',
	},

	confluenceIconLabel: {
		defaultMessage: 'Confluence',
		description: 'Accessibility label for the Confluence page icon',
		id: 'townsquare.twc-onboarding-modal.confluence-icon-label',
	},

	loomIconLabel: {
		defaultMessage: 'Loom',
		description: 'Accessibility label for the Loom video icon',
		id: 'townsquare.twc-onboarding-modal.loom-icon-label',
	},

	integrationIconLabel: {
		defaultMessage: 'Integration',
		description: 'Accessibility label for the integration globe icon',
		id: 'townsquare.twc-onboarding-modal.integration-icon-label',
	},

	atlassianLogoLabel: {
		defaultMessage: 'Atlassian',
		description: 'Accessibility label for the Atlassian company logo',
		id: 'townsquare.twc-onboarding-modal.atlassian-logo-label',
	},

	appsIconLabel: {
		defaultMessage: 'Apps',
		description: 'Accessibility label for the Apps icon',
		id: 'townsquare.twc-onboarding-modal.apps-icon-label',
	},

	homeIconLabel: {
		defaultMessage: 'Home',
		description: 'Accessibility label for the Home icon',
		id: 'townsquare.twc-onboarding-modal.home-icon-label',
	},

	teamsIconLabel: {
		defaultMessage: 'Integration',
		description: 'Accessibility label for the Teams icon',
		id: 'townsquare.twc-onboarding-modal.teams-icon-label',
	},

	alignTextLeftLabel: {
		defaultMessage: 'Align Text Left',
		description: 'Accessibility label for the icon showing text aligned to the left',
		id: 'townsquare.twc-onboarding-modal.left-align-icon-label',
	},
});
